import React, {
  useContext, useLayoutEffect, useEffect, useState,
} from 'react'
import PropTypes from 'prop-types'
import { cookieBanner } from '@gousto-internal/storage-consent-web-package'
import { store } from './store'
import { setAuthentication } from './actions/auth'
import { getValueFromCookie } from './utils'
import { AppContent } from './components/AppContent'
import { ContentLoader } from './components/ContentLoader'
import { getHasCheckedAuthentication } from './selectors/auth'
import { initializeDatadog } from './observability/datadog'
import { goustoAPI } from './config/routes'
import { cookieBannerActions } from './config/cookieBanner'
import '@gousto-internal/storage-consent-web-package/dist/storageConsentBanner.css'

const App = ({ basename }) => {
  const { dispatch, state } = useContext(store)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    initializeDatadog()
    cookieBanner.init(cookieBannerActions)
  }, [])

  useLayoutEffect(() => {
    // getting the cookie only for local development
    const accessToken = getValueFromCookie('v1_oauth_token', 'access_token')

    const checkLogin = async () => {
      if (accessToken) {
        setIsAuthenticated(true)
      } else {
        try {
          const res = await global.fetch(goustoAPI.currentUser, { credentials: 'include' })
          setIsAuthenticated(res.ok)
        } catch {
          setIsAuthenticated(false)
        }
      }
    }
    checkLogin()

    dispatch(setAuthentication({
      accessToken,
      hasCheckedAuthentication: true,
      isAuthenticated,
    }))
  }, [dispatch, isAuthenticated])

  return getHasCheckedAuthentication(state) ? <AppContent basename={basename} /> : <ContentLoader />
}

App.propTypes = {
  basename: PropTypes.string.isRequired,
}

export { App }
